import {Component, Inject, ChangeDetectorRef} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {Customer} from '../../model/Entities/Customer';
import {FormControl, Validators} from '@angular/forms';
import {PaymentType} from '../../model/Entities/PaymentType';
import {numberValidator} from '../../validators/number.validator';
import {CustomerService} from '../../services/customer.service';
import {SnackService} from '../../services/snack.service';
import {AresService} from '../../services/ares.service';
import {AresResponse} from '../../model/Entities/AresResponse';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';

@Component({
    selector: 'customer-create-dialog',
    templateUrl: './customer-create.dialog.component.html',
    styleUrls: ['./customer-create.dialog.component.scss']
})
export class CustomerCreateDialogComponent {

    customer: Customer = new Customer();
    paymentTypeEnum: any = PaymentType;
    saving = false;

    nameFC = new FormControl('', [Validators.required]);
    invoiceNameFC = new FormControl('', [Validators.required]);
    invoiceStreetFC = new FormControl('', []);
    invoiceCityFC = new FormControl('', []);
    invoiceZipFC = new FormControl('', []);
    companyNumberFC = new FormControl('', [Validators.required]);
    emailFC = new FormControl('', [Validators.email]);
    phoneFC = new FormControl('', []);
    saleFC = new FormControl('', [
        Validators.required,
        Validators.min(0),
        Validators.max(100),
        numberValidator()
    ]);
    lossSaleFC = new FormControl(false, [Validators.required]);

    addresses: any[] = [];
    addressSearchValue = '';

    constructor(
        public dialog: MatDialogRef<CustomerCreateDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private customerService: CustomerService,
        private snackService: SnackService,
        private aresService: AresService,
        private http: HttpClient,
        private cdr: ChangeDetectorRef
    ) {
    }

    checkValidity(): boolean {
        return this.nameFC.valid
            && this.customer.address && this.customer.addressLat && this.customer.addressLon
            && this.invoiceNameFC.valid
            && this.invoiceStreetFC.valid
            && this.invoiceCityFC.valid
            && this.invoiceZipFC.valid
            && (!this.customer.enterprise || this.companyNumberFC.valid)
            && this.saleFC.valid;
    }

    nameChange(): void {
        if (this.customer.invoiceName === '') {
            this.customer.invoiceName = this.customer.name;
        }
    }

    onCompanyNumberChange(): void {
        const ico = this.customer.invoiceCompanyNumber;
        if (ico && ico.length === 8) {
            this.loadFromAres(ico);
        }
    }

    loadFromAres(ico: string): void {
        this.aresService.getByIco(ico).subscribe(
            (data: AresResponse) => {
                this.customer.name = data.name;
                this.customer.invoiceName = data.invoiceName;
                this.customer.invoiceVatNumber = data.invoiceVatNumber;
                this.customer.invoiceVatPayer = data.invoiceVatPayer;

                if (data.invoiceStreet && data.invoiceCity) {
                    const address = `${data.invoiceStreet}, ${data.invoiceCity}, ${data.invoiceZip}`;
                    this.addressSearchValue = address;
                    this.loadAddresses(address, true);
                }

                this.snackService.showSuccess('Data z ARES byla načtena');
                this.cdr.detectChanges();
            }
        );
    }

    searchAddress($event: KeyboardEvent) {
        const search = $event.target['value'];
        this.loadAddresses(search);
    }

    loadAddresses(search: string, autoSelect: boolean = false) {
        if (!search || search.length < 3) {
            this.addresses = [];
            return;
        }

        const apiKey = environment.apiMapyCom;
        const url = `https://api.mapy.com/v1/suggest?query=${encodeURIComponent(search)}&type=regional.address,poi&apiKey=${apiKey}`;

        this.http.get<any>(url).subscribe(
            (response) => {
                this.addresses = response.items || [];
                if (autoSelect && this.addresses.length === 1) {
                    this.selectAddress(this.addresses[0]);
                }
            },
            (error) => {
                console.error('Nepodařilo se načíst adresy:', error);
                this.addresses = [];
            }
        );
    }

    selectAddress(address) {
        this.customer.invoiceCity = '';
        this.customer.invoiceZip = '';
        this.customer.invoiceStreet = '';
        let hasMunicipalityPart = address.regionalStructure.some(s => s.type === 'regional.municipality_part');
        address.regionalStructure.forEach(structure => {
            if (structure.type === 'regional.municipality_part') {
                if (this.customer.invoiceCity !== '') {
                    this.customer.invoiceCity = structure.name + ' - ' + this.customer.invoiceCity;
                } else {
                    this.customer.invoiceCity = structure.name;
                }
            }
            if (structure.type === 'regional.municipality' && !hasMunicipalityPart) {
                this.customer.invoiceCity = structure.name;
            }
            if (structure.type === 'regional.street' || structure.type === 'regional.address') {
                this.customer.invoiceStreet = structure.name + ' ' + this.customer.invoiceStreet;
            }
        });
        this.customer.invoiceZip = address.zip;
        this.customer.address = address.name + ', ' + address.zip + ', ' + address.location;
        this.customer.addressLat = address.position.lat;
        this.customer.addressLon = address.position.lon;
    }

    saveAndUse(): void {
        this.saving = true;
        this.customerService.save(this.customer).subscribe(
            (customer: Customer) => {
                this.snackService.showSuccess(`Objednatel ${customer.name} byl vytvořen`);
                this.saving = false;
                this.dialog.close(customer);
            },
            (error) => {
                this.snackService.showWarn('Nepodařilo se vytvořit objednatele');
                this.saving = false;
            }
        );
    }
}



// WEBPACK FOOTER //
// /app/src/CustomersModule/CustomerCreateDialogComponent/customer-create.dialog.component.ts